import { useMutation, gql } from '@apollo/client';

export const DELETE_COMPANY_BUSINESS_ADDRESS_BY_ID = gql`
  mutation deleteBusinessAddressById($businessAddressId: ObjectId!) {
    deleteBusinessAddressById(businessAddressId: $businessAddressId)
  }
`;

export const useDeleteCompanyBusinessAddressById = () => {
  const [deleteCompanyBusinessAddressById] = useMutation(DELETE_COMPANY_BUSINESS_ADDRESS_BY_ID);

  return deleteCompanyBusinessAddressById;
};
